const bindings = new WeakMap();
export function bindEvent(target, type, callback) {
    const binding = {
        callback: callback,
        listener: (event) => binding.callback(event),
    };
    const targetBindings = bindings.get(target) ?? new Map();
    targetBindings.set(type, binding);
    bindings.set(target, targetBindings);
    target.addEventListener(type, binding.listener);
}
export function refreshEvents(current, next) {
    const currentBindings = bindings.get(current);
    const nextBindings = bindings.get(next);
    if (!nextBindings) {
        if (currentBindings) {
            for (const [type, binding] of currentBindings)
                current.removeEventListener(type, binding.listener);
            bindings.delete(current);
        }
        return;
    }
    const retained = currentBindings ?? new Map();
    for (const [type, binding] of retained) {
        if (!nextBindings.has(type)) {
            current.removeEventListener(type, binding.listener);
            retained.delete(type);
        }
    }
    for (const [type, nextBinding] of nextBindings) {
        next.removeEventListener(type, nextBinding.listener);
        const existing = retained.get(type);
        if (existing)
            existing.callback = nextBinding.callback;
        else {
            retained.set(type, nextBinding);
            current.addEventListener(type, nextBinding.listener);
        }
    }
    bindings.set(current, retained);
}
//# sourceMappingURL=events.js.map